import React from "react";
// types
import type { ICustomWidgetTypeProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import {
    CouponListingPLWidgetTypes,
    ICouponCardTextBanner,
    ICouponSectionComm,
    ICouponCard,
} from "@swiggy-private/cart-types";
// components
import { CouponTextBanner } from "@swiggy-private/cart-ui";
import CouponsWrapper from "../CouponsWrapper";
import CouponSectionComms from "../CouponSectionComms";

export const customWidgetTypeHandler = (card: ICustomWidgetTypeProps) => {
    try {
        switch (card["@type"]) {
            case CouponListingPLWidgetTypes.COUPON_CARD:
                return <CouponsWrapper card={card as ICouponCard} />;
            case CouponListingPLWidgetTypes.COUPON_TEXT_BANNER:
                return <CouponTextBanner data={card as ICouponCardTextBanner} />;
            case CouponListingPLWidgetTypes.COUPON_SECTION_COMMS:
                return <CouponSectionComms {...(card as ICouponSectionComm)} />;
            default:
                return null;
        }
    } catch (e) {
        throw new Error(`Error in customWidgetTypeHandler : ${JSON.stringify(e)}`);
    }
};
